<template>
  <div :class="[viewType === 'view_2' ? 'size-reco-product-column' : '']">
    <div class="size-reco-product-img">
      <!-- <img src="https://cdn.shopify.com/s/files/1/0100/4945/4137/products/Corbeille-Black-Dawn_1800x.jpg?v=1677081087" alt="Nooparis" /> -->
      <img :src="productImgLink" alt="Nooparis" />
    </div>
    <div class="size-reco-product">
      {{ productName }}
      <span style="color:gray;">
        {{ productPrice }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductView",
  components: { },
  props: {
    viewType: {
      type: String,
      default: () => {},
    },
    productImgLink: {
      type: String,
      default: () => {},
    },
    productName: {
      type: String,
      default: () => {},
    },
    productPrice: {
      type: String,
      default: () => {},
    },
  },
  data() {
    return { };
  },
  mounted() { },
  methods: { },
};
</script>

<style scoped>

.size-reco-product {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  font-weight: bolder;
}


.size-reco-product-column {
  height: 175px !important;
  align-items: center !important;
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}

.size-reco-product-img {
  display: block !important;
  width: 200px !important;
  height: 275px !important;
  max-width: 200px !important;
  max-height: 275px !important;
  margin: auto !important;
}

.size-reco-product-img img {
  width: 100% !important;
  margin-bottom: 20px !important;
  border-radius: 5px !important;
}

.size-reco-product-column .size-reco-product-img {
  height: 175px !important;
  max-height: 175px !important;
  width: 140px !important;
  max-width: 140px !important;
  margin: auto !important;
  margin-bottom: 35px !important;
}

@media screen and (max-width: 450px) {
  .size-reco-product-column .size-reco-product-img {
    height: auto !important;
    max-height: none !important;
    width: 100px !important;
    max-width: 100px !important;
    margin-bottom: 15px !important;
  }

  .size-reco-product-img {
    width: 150px !important;
    height: auto !important;
    max-width: 150px !important;
    max-height: none !important;
    margin: auto !important;
  }
}

@media screen and (max-width: 375px) {
  .size-reco-product-img {
    width: 130px !important;
    max-width: 130px !important;
  }

  .size-reco-product-column .size-reco-product-img {
    width: 80px !important;
    max-width: 80px !important;
  }
}
</style>
